import React, { Component } from 'react'
import BaseHeader from '../shared/Section/Header'

export class Header extends Component {
  render() {
    return (
      <BaseHeader
        headline={`Choose a plan that's right for you
      `}
        title="Simple Pricing Plans"
        description="Mosto has plans, from free to paid, that scale with your needs. Subscribe to a plan that fits the size of your business."
        {...this.props}
      ></BaseHeader>
    )
  }
}

export default Header
